import { HistoryList } from '../components/History';
import { useProject } from '../lib/project';

export function ProjectHistoryPage() {
  const { project, tagsVersion } = useProject();
  return (
    <div className="section">
      <div className="page-header">
        <div className="page-title">
          <h2>History</h2>
          <p className="muted small">Every change in this project, newest first — made on the web, through MCP or the CLI.</p>
        </div>
      </div>
      <HistoryList key={tagsVersion} target="project" id={project.id} />
    </div>
  );
}
